import axios from 'axios';
import { useCallback, useState } from 'react';

const useDnsCheck = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const submitCheck = useCallback(async (domain) => {
    if (!domain) {
      console.log('No domain entered');
      return;
    }
    setIsLoading(true);
    setError(null);

    try {
      // Set a timeout for the request
      const apiUrl =
        process.env.NODE_ENV === 'development'
          ? `http://localhost:3001/api/dns/${domain}`
          : `https://dns-analyzer-backend.vercel.app/api/dns/${domain}`;

      const response = await axios.get(apiUrl, { timeout: 10000 });

      // Debug the certificate info
      console.log('Full response data:', response.data);
      if (response.data.certificateInfo) {
        console.log('Certificate Info:', response.data.certificateInfo);
      } else {
        console.log('No certificate info in the response');
      }

      setData(response.data);
    } catch (err) {
      console.error('Error fetching DNS data:', err);
      setError(err.message || 'Error occurred while fetching DNS data');
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { data, isLoading, error, submitCheck };
};

export default useDnsCheck;
